const initialState = {
  academic_year: '',
  campus_code: '',
  faculty_code: '',
  department_code: '',
  major_code: '',
  edulevel_code: '',
  semester: '',
}
// announcement_advisor_date: settings.announcementAdvisorDate,
//   announcement_advisor_type: settings.announcementAdvisorType,
//   announcement_type: settings.announcementType,
export default function (state = initialState, action) {
  //console.log(action.type);
  //console.log(action.payload);
  switch (action.type) {
    case 'ADD_SETTING':
      return action.payload

    default:
      return state
  }
}
